<utc-base-layout class="hvac-homepage">
    <div class="hvac-homepage-content">
        <div class="hvac-homepage-hero" id="main-content">
            <div [ngClass]="{'hidden': !showCBPBackgroup}"
                class="hvac-homepage-hero-pattern-elements">
                <utc-svg class="hvac-homepage-hero-pattern rellax" data-rellax-speed="-10"
                    src="assets/images/home-pattern.svg">
                </utc-svg>
                <utc-svg class="hvac-hvac-product-illustration hvac-hvac-product-1 rellax" data-rellax-speed="-7"
                    data-rellax-percentage="0.5" src="assets/images/home-illustration-1.svg"></utc-svg>
                <utc-svg class="hvac-hvac-product-illustration hvac-hvac-product-2 rellax" data-rellax-speed="-6"
                    src="assets/images/home-illustration-2.svg"></utc-svg>
                <utc-svg class="hvac-hvac-product-illustration hvac-hvac-product-3 rellax" data-rellax-speed="-8"
                    src="assets/images/home-illustration-3.svg"></utc-svg>
                <utc-svg class="hvac-hvac-product-illustration hvac-hvac-product-4 rellax" data-rellax-speed="-8"
                    src="assets/images/home-illustration-4.svg"></utc-svg>
                <utc-svg class="hvac-hvac-product-illustration hvac-hvac-product-5 rellax" data-rellax-speed="-7"
                    src="assets/images/home-illustration-5.svg"></utc-svg>
                <utc-svg class="hvac-hvac-product-illustration hvac-hvac-product-6 rellax" data-rellax-speed="-8"
                    src="assets/images/home-illustration-6.svg"></utc-svg>
                <utc-svg class="hvac-hvac-product-illustration hvac-hvac-product-7 rellax" data-rellax-speed="-9"
                    src="assets/images/home-illustration-7.svg"></utc-svg>
                <utc-svg class="hvac-hvac-product-illustration hvac-hvac-product-8 rellax" data-rellax-speed="-7"
                    src="assets/images/home-illustration-8.svg"></utc-svg>
                <utc-svg class="hvac-hvac-product-illustration hvac-hvac-product-9 rellax" data-rellax-speed="-10"
                    src="assets/images/home-illustration-9.svg"></utc-svg>
                <utc-svg class="hvac-hvac-product-illustration hvac-hvac-product-10 rellax" data-rellax-speed="-10"
                    src="assets/images/home-illustration-10.svg"></utc-svg>
                <utc-svg class="hvac-hvac-product-illustration hvac-hvac-product-11 rellax" data-rellax-speed="-7"
                    src="assets/images/home-illustration-11.svg"></utc-svg>
            </div>
            <div [ngClass]="{'hidden': showCBPBackgroup}"
                class="hvac-homepage-hero-pattern-elements">
                <utc-svg class="hvac-homepage-hero-pattern rellax" data-rellax-speed="-10"
                    src="assets/images/home-pattern.svg">
                </utc-svg>
                <utc-svg class="hvac-hvac-product-illustration hvac-hvac-icp-product-1 rellax" data-rellax-speed="-7"
                    data-rellax-percentage="0.5" src="assets/images/icp-home-illustration-4.svg"></utc-svg>
                <utc-svg class="hvac-hvac-product-illustration hvac-hvac-icp-product-2 rellax" data-rellax-speed="-6"
                    src="assets/images/icp-home-illustration-2.svg"></utc-svg>
                <utc-svg class="hvac-hvac-product-illustration hvac-hvac-icp-product-3 rellax" data-rellax-speed="-8"
                    src="assets/images/icp-home-illustration-1.svg"></utc-svg>
                <utc-svg class="hvac-hvac-product-illustration hvac-hvac-icp-product-4 rellax" data-rellax-speed="-8"
                    src="assets/images/icp-home-illustration-3.svg"></utc-svg>
                <utc-svg class="hvac-hvac-product-illustration hvac-hvac-icp-product-5 rellax" data-rellax-speed="-7"
                    src="assets/images/icp-home-illustration-5.svg"></utc-svg>
                <utc-svg class="hvac-hvac-product-illustration hvac-hvac-icp-product-6 rellax" data-rellax-speed="-8"
                    src="assets/images/icp-home-illustration-6.svg"></utc-svg>
                <utc-svg class="hvac-hvac-product-illustration hvac-hvac-icp-product-7 rellax" data-rellax-speed="-9"
                    src="assets/images/icp-home-illustration-7.svg"></utc-svg>
                <utc-svg class="hvac-hvac-product-illustration hvac-hvac-icp-product-8 rellax" data-rellax-speed="-7"
                    src="assets/images/icp-home-illustration-9.svg"></utc-svg>
                <utc-svg class="hvac-hvac-product-illustration hvac-hvac-icp-product-9 rellax" data-rellax-speed="-10"
                    src="assets/images/icp-home-illustration-7.svg"></utc-svg>
                <utc-svg class="hvac-hvac-product-illustration hvac-hvac-icp-product-10 rellax" data-rellax-speed="-10"
                    src="assets/images/icp-home-illustration-2.svg"></utc-svg>
            </div>
            <div class="hvac-homepage-hero-content">
                <div class="hvac-content-container">
                    <hvac-toast class="hvac-content-container-banner"></hvac-toast>
                    <a class='hvac-covid-banner-link' *ngIf="showCovidInfo" routerLink="/covid">
                        <div class='hvac-covid-banner'>
                            <div class='hvac-covid-banner-info-badge'>
                                <utc-svg class='hvac-covid-banner-info-badge-svg' src="assets/images/info-badge.svg">
                                </utc-svg>
                            </div>
                            <div class='hvac-covid-banner-content'>
                                <p class="hvac-covid-banner-text">{{ 'HOMEPAGE.COVID_INFO.BANNER' | translate }}</p>
                                <a class='hvac-covid-banner-button'>{{ 'HOMEPAGE.COVID_INFO.BUTTON' | translate }}</a>
                            </div>
                        </div>
                    </a>
                    <div class='hvac-icp-alerts-container' *ngIf="fixedPageContent && fixedPageContent.alerts">
                        <hvac-alert [alerts]="fixedPageContent.alerts"></hvac-alert>
                        <hvac-notification [notification]="this.fixedPageContent.notifications"></hvac-notification>
                    </div>
                    <div [class.hvac-homepage-hero-logo-dayandnight]="brand === 'Day & Night'"
                        [class.hvac-homepage-hero-logo-icp]="isICP && brand !== 'Day & Night'"
                        [class.hvac-homepage-hero-logo-totaline]="brand === 'Totaline'"
                        class="hvac-homepage-hero-logo">
                            <utc-svg *ngIf="brand === 'Totaline'; else otherBrands" [src]="'assets/images/logo.svg'"></utc-svg>
                            <ng-template  #otherBrands>
                                <img class="hvac-homepage-hero-logo-img"
                                    [src]="(brand === 'Airquest' && isICP ) ? 'assets/images/airquest.png' : 'assets/images/logo.png'"
                                    alt="{{ brandLogoAltText }}" />
                            </ng-template>
                    </div>
                    <div *ngIf="heroContent && heroContent.title" class="hvac-homepage-hero-intro">
                        <h1 class="hvac-hero-large-text"
                            [innerHTML]="heroContent.title.Content.title | richText"></h1>
                        <p class="hvac-hero-normal-text"
                            [innerHTML]="heroContent.title.Content.text | richText"></p>
                        <hvac-search-hero [searchConfig]="heroContent.search"></hvac-search-hero>
                    </div>
                </div>
            </div>
        </div>
        <hvac-signup-newsletter></hvac-signup-newsletter>

        <div class="hvac-homepage-body" *ngIf="fixedPageContent && (fixedPageContent.browse || fixedPageContent.whatsnew || fixedPageContent.quicklinks || (brand === 'Totaline' && fixedPageContent.whatsnewDynamic))">
            <div class="hvac-content-container hvac-landing-page-content" [ngClass]="{ 'hvac-icp-landing-page' : isICP }">
                <div class="hvac-full-width">
                    <div class="hvac-content-container">
                        <hvac-icp-interactive-questionnaire *ngIf="isICP && showRegulatoryQuestionnaire"></hvac-icp-interactive-questionnaire>
                    </div>
                </div>
                <div *ngIf="fixedPageContent && fixedPageContent.browse">
                    <hvac-browse [data]="fixedPageContent.browse"></hvac-browse>
                </div>
                <div class="hvac-homepage-whats-new-quicklinks-container">
                    <div class='hvac-homepage-whats-new' *ngIf="fixedPageContent && fixedPageContent.whatsnewStatic; else whatsnewdynamic">
                        <hvac-whats-new [whatsNew]="fixedPageContent.whatsnewStatic"></hvac-whats-new>
                    </div>
                    <ng-template #whatsnewdynamic>
                        <div class='hvac-homepage-whats-new' *ngIf="fixedPageContent && fixedPageContent.whatsnewDynamic">
                            <hvac-document-list [data]="fixedPageContent.whatsnewDynamic"></hvac-document-list>
                        </div>
                    </ng-template>
                    <div class='hvac-homepage-quicklinks' *ngIf="fixedPageContent && fixedPageContent.quicklinks">
                        <hvac-quick-links [inputLinks]="fixedPageContent.quicklinks"></hvac-quick-links>
                    </div>
                </div>
                <utc-content-section [sectionData]="remainingPageContent$"></utc-content-section>
            </div>
            <app-signup-panel *ngIf="showGoSiteRegistration"></app-signup-panel>

        </div>
    </div>
    <div *ngIf='isLogoutRedirect' class='hvac-logout-frame'>
        <iframe [src]="logoutFrameUrl | safe:'resourceUrl'" width="0" height="0"></iframe>
    </div>
</utc-base-layout>
